export default "\r\n<kendo-menu [items]=\"navigationItems\" (select)=\"onSelect($event)\"></kendo-menu>\r\n<router-outlet></router-outlet>";